import dayjs from "lib/dayjs";

const DATE_FIELDS = ["firstCouponDate", "firstPrincipalDate", "finalMaturityDate"];

function validDate(value) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const parsed = dayjs(value);
  return parsed.isValid() && parsed.format("YYYY-MM-DD") === value ? parsed : null;
}

function frequencyMonths(value) {
  const frequency = String(value || "semiannual").toLowerCase();
  if (frequency.startsWith("month")) return 1;
  if (frequency.startsWith("quarter")) return 3;
  if (frequency.startsWith("annual")) return 12;
  return 6;
}

function firstCouponAfterDelivery(maturity, delivery, months) {
  let coupon = maturity;
  for (let guard = 0; guard < 1200 && coupon.isAfter(delivery, "day"); guard++) {
    const previous = coupon.subtract(months, "month");
    if (!previous.isAfter(delivery, "day")) return coupon.format("YYYY-MM-DD");
    coupon = previous;
  }
  return "";
}

export function deriveRefundingDateDefaults(form = {}) {
  if (form.refundingMode && form.refundingMode !== "ds_issue") return null;
  const entries = Array.isArray(form.refunded_issues) ? form.refunded_issues : [];
  const maturities = entries
    .filter((entry) => entry?.entry_type === "ds_issue")
    .flatMap((entry) => Array.isArray(entry.selected_maturities) ? entry.selected_maturities : [])
    .map((row) => validDate(row?.maturity_date))
    .filter(Boolean)
    .sort((a, b) => a.valueOf() - b.valueOf());

  if (!maturities.length) return null;

  const delivery = validDate(form.deliveryDate || form.delivery_date);
  let firstCouponDate = "";
  let ambiguousFirstCouponDate = false;
  if (delivery) {
    const couponDates = [...new Set(maturities.map((maturity) =>
      firstCouponAfterDelivery(maturity, delivery, frequencyMonths(form.couponFrequency || form.coupon_frequency))
    ))];
    if (couponDates.length === 1) firstCouponDate = couponDates[0];
    else ambiguousFirstCouponDate = true;
  }

  return {
    firstCouponDate,
    firstPrincipalDate: maturities[0].format("YYYY-MM-DD"),
    finalMaturityDate: maturities[maturities.length - 1].format("YYYY-MM-DD"),
    ambiguousFirstCouponDate,
  };
}

export function applyRefundingDateDefaults(previousForm, nextForm) {
  const previous = deriveRefundingDateDefaults(previousForm);
  const next = deriveRefundingDateDefaults(nextForm);
  if (!next && !previous) return nextForm;

  let updated = nextForm;
  for (const field of DATE_FIELDS) {
    const current = String(previousForm?.[field] || "");
    const previousDefault = previous?.[field] || "";
    if (current && current !== previousDefault) continue;
    const nextDefault = next?.[field] || "";
    if (String(updated[field] || "") !== nextDefault) {
      if (updated === nextForm) updated = { ...nextForm };
      updated[field] = nextDefault;
    }
  }
  return updated;
}
